import ShopifyNotifications from '~/components/LandingPageConversion/ShopifyNotifications';

const Feature1 = () => {
	return (
		<section className="container-lp relative mx-auto flex flex-wrap items-center justify-center">
			<div className="card-bg reltive z-10 flex w-full flex-col px-6 py-10 backdrop-blur-md lg:px-20 lg:py-20">
				<div className="mx-auto flex max-w-3xl flex-col gap-6 px-4">
					<h2 className="text-transparent mx-auto bg-clip-text text-center text-3xl font-extrabold sm:text-4xl lg:text-5xl lg:leading-[60px]">
						<span className="text-transparent bg-gradient-to-b from-white from-70% to-[#b2b2b2] bg-clip-text">
							Eliminate Guesswork and{' '}
						</span>
						<span className="text-transparent bg-gradient-to-b from-white from-30% to-[#7496F8] bg-clip-text">
							Watch Your Profits Soar{' '}
						</span>
					</h2>

					<div className="text-center text-lg text-white lg:text-xl">
						PagePilot.ai Uses Proven Conversion Techniques to Give You a Competitive Edge. Test more products, faster,
						cheaper and with better results.
					</div>
				</div>

				<div className="mt-10 grid items-center gap-10 md:mt-20 md:grid-cols-2">
					<div className="order-2 flex flex-col space-y-6 lg:order-1">
						<div className="text-2xl font-semibold text-white">
							Grow your store's profitability while spending less time and less money
						</div>
						<p className="text-base text-gray-DEFAULT-400 md:text-lg">
							Say Goodbye to Costly Copywriters and Designers. PagePilot's AI Creates Perfect Product Pages Instantly,
							Letting You Focus on Growing Your Store.
						</p>
						<ul className="flex flex-col gap-2">
							<li className="flex items-center">
								<svg
									className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
								</svg>
								<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
									Inefficient and time-consuming manual work
								</span>
							</li>
							<li className="mt-2 flex items-center">
								<svg
									className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
								</svg>
								<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
									The high cost of human resources
								</span>
							</li>
							<li className="mt-2 flex items-center">
								<svg
									className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
								</svg>
								<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
									Falling behind the competition
								</span>
							</li>
							<li className="mt-2 flex items-center">
								<svg
									className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
								</svg>
								<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
									Inconsistent quality and output
								</span>
							</li>
							<li className="mt-2 flex items-center">
								<svg
									className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
								</svg>
								<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
									Limited scalability and flexibility
								</span>
							</li>
							<li className="mt-2 flex items-center">
								<svg
									className="relative top-1 h-4 w-4 fill-greenPrimary md:top-0"
									viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z"></path>
								</svg>
								<span className="ml-3 text-base text-white md:text-lg md:text-gray-DEFAULT-400">
									Spending big on ads without getting sales
								</span>
							</li>
						</ul>
					</div>
					<div className="order-1 flex flex-col space-y-6 lg:order-2">
						<ShopifyNotifications />
					</div>
				</div>
			</div>
			<img
				src="images/landingpage/neon1.webp"
				className="animate-smoothMove absolute -right-[100px] -top-[60px] hidden max-w-[300px] lg:z-20 lg:block"
				alt="PagePilot.aiNeon"
				width="300"
				height="300"
			/>
		</section>
	);
};

export default Feature1;
